import dayjs from "dayjs";
import { MAX_NEW_TOUCHPOINTS, surveyStates, ATTACHMENT_ENDPOINT } from "./constants";
import IconDOC from "../components/svgs/IconDOC";
import IconPDF from "../components/svgs/IconPDF";
import IconPPT from "../components/svgs/IconPPT";
import IconTXT from "../components/svgs/IconTXT";
import IconXLS from "../components/svgs/IconXLS";
import IconUnknown from "../components/svgs/IconUnknown";
import IconImages from "../components/svgs/IconImages";
import IconVideos from "../components/svgs/IconVideos";

import { isProd } from "./isProd";

export const getLastWeekTP = (touchpoints, profileId) => {
  let lastweek = dayjs().subtract(7, "day");
  let newToucpoints = touchpoints.filter(t => t.user._id !== profileId && dayjs(t.createdAt).isAfter(lastweek));
  return newToucpoints;
};

export const getLast5TP = (touchpoints, profileId) => {
  let newToucpoints = touchpoints.filter(t => t.user._id !== profileId).slice(0, MAX_NEW_TOUCHPOINTS);
  return newToucpoints;
};

export const getPiePercentage = (green, yellow, red) => {
  const sum = green + yellow + red;
  let greenPer = 0;
  let yellowPer = 0;
  let redPer = 0;
  if (green && yellow && red) {
    greenPer = 100 - Math.round((100 * yellow) / sum) - Math.round((100 * red) / sum);
    yellowPer = Math.round((100 * yellow) / sum);
    redPer = Math.round((100 * red) / sum);
  }

  if (!green) {
    if (yellow) {
      greenPer = 0;
      yellowPer = 100;
      redPer = 0;
    }
    if (red) {
      greenPer = 0;
      yellowPer = 0;
      redPer = 100;
    }
    if (yellow && red) {
      greenPer = 0;
      yellowPer = Math.round((100 * yellow) / sum);
      redPer = 100 - Math.round((100 * yellow) / sum);
    }
  }

  if (!yellow) {
    if (red) {
      greenPer = 0;
      yellowPer = 0;
      redPer = 100;
    }
    if (green) {
      greenPer = 100;
      yellowPer = 0;
      redPer = 0;
    }
    if (green && red) {
      greenPer = Math.round((100 * green) / sum);
      yellowPer = 0;
      redPer = 100 - Math.round((100 * green) / sum);
    }
  }

  if (!red) {
    if (green) {
      greenPer = 100;
      yellowPer = 0;
      redPer = 0;
    }
    if (red) {
      greenPer = 0;
      yellowPer = 0;
      redPer = 100;
    }
    if (green && yellow) {
      greenPer = Math.round((100 * green) / sum);
      yellowPer = 100 - Math.round((100 * green) / sum);
      redPer = 0;
    }
  }

  return { greenPer, yellowPer, redPer };
};

export const showOverlay = (tp, role) => {
  return tp.surveyState === surveyStates.started && role !== "auditor";
};

export const surveyStarted = touchPoint => touchPoint.surveyState === surveyStates.started;

export const getExtensionIcon = (name, altColor) => {
  const fileExtension = getFileExt(name);

  switch (fileExtension) {
    case "doc":
    case "docx":
      return <IconDOC color={altColor} />;
    case "pdf":
      return <IconPDF color={altColor} />;
    case "ppt":
    case "pptx":
      return <IconPPT color={altColor} />;
    case "txt":
      return <IconTXT color={altColor} />;
    case "xls":
    case "xlsx":
      return <IconXLS color={altColor} />;
    case "PNG":
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return <IconImages color={altColor} />;
    case "mp4":
    case "mov":
    case "wmv":
    case "avi":
      return <IconVideos color={altColor} />;
    default:
      return <IconUnknown color={altColor} />;
  }
};

export const formatBytes = (bytes, decimals = 1) => {
  if (bytes === 0) return "0 bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getAttachmentDownloadUrl = attachment => {
  if (attachment && (attachment.split(":")[0] === "https" || attachment.split(":")[0] === "http")) {
    return attachment;
  }
  const attachmentFolder = isProd() ? "production" : "staging";
  return `${ATTACHMENT_ENDPOINT}${attachmentFolder}/${attachment}`;
};

const getFileExt = name => {
  const ext = name && name.substring(name.lastIndexOf(".") + 1, name.length);
  return ext || "";
};

export const filterTPsByAudit = (tps, audit) => {
  return tps.filter(tp => tp.auditResults.some(auditResult => auditResult.auditId === audit));
};
